import React, { useState } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Row from "./Row";

const Table = ({ 
  className, 
  items = [], 
  onFolderSelect
}) => {
  const [activeId, setActiveId] = useState(null);

  const handleFolderClick = (id) => {
    if (onFolderSelect) {
      onFolderSelect(id);
    }
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={cn(styles.row, styles.header)}>
          <div className={styles.col}>Contrat / Convention</div>
          <div className={styles.col}>N° Dossier</div>
          <div className={styles.col}>Date</div>
          <div className={styles.col}>Progression</div>
          <div className={styles.col}>Statut</div>
          <div className={styles.col}>Actions</div>
        </div>
        {items.length > 0 ? (
          items.map((x, index) => (
            <Row
              item={x}
              key={index}
              onClick={() => handleFolderClick(x.id)}
            />
          ))
        ) : (
          <div className={styles.noData}>Aucune donnée disponible</div>
        )}
      </div>
    </div>
  );
};

export default Table;
